module.exports = __webpack_public_path__ + "img/Flag_of_Nauru.3b463166.svg";